import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StyledEngineProvider } from "@material-ui/core";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { version } from "../package.json";
// import UnderConstructionScreen from "./underConstruction/UnderConstructionScreen";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://53901bed77244b2c89beffb96491eab4@sentry.routetitan.io/5",
        environment: process.env.REACT_APP_ENVIRONMENT,
        release: version,
        normalizeDepth: 4,
        integrations: [new Integrations.BrowserTracing()]
        // Disable transaction for now.
        // tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0
    });
}

export const supportedLanguages = [
  ["en", "English"],
  ["nl", "Nederlands"],
  ["de", "Deutsch"]
];

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
